import { map, pipe } from 'wonka';
import { addFragmentsFromDirectives, replaceDirectivesByFragments } from './directive-utils';
import { resolveData } from './resolve-data';
export function computedExchange({ entities }) {
    return ({ forward }) => (op$) => pipe(op$, map((op) => {
        const { query } = op;
        const augmentedOp = op;
        augmentedOp.originalQuery = query;
        augmentedOp.mixedQuery = addFragmentsFromDirectives(query, entities);
        augmentedOp.query = replaceDirectivesByFragments(query, entities);
        return augmentedOp;
    }), forward, map((res) => {
        const { data } = res;
        const augmentedRes = res;
        augmentedRes.rawData = data;
        augmentedRes.data = resolveData(data, augmentedRes.operation, entities);
        augmentedRes.operation.query = augmentedRes.operation.originalQuery;
        return res;
    }));
}
//# sourceMappingURL=computed-exchange.js.map